import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PhotoService } from '../../services/photo.service';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-cartographie',
  templateUrl: './cartographie.component.html',
  styleUrls: ['./cartographie.component.scss'],
})
export class CartographieComponent implements OnChanges {
  @Input() report!: Report;

  cartographieBinary!: string;

  constructor(private readonly photoService: PhotoService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.changes(changes);
  }

  private async changes(changes: SimpleChanges) {
    if (changes['report']?.currentValue) {
      this.cartographieBinary = await this.photoService.getMap(this.report.id);
    }
  }
}
